export const CLASS_NAME = 'cst-switch'
